import type { UseSelectRecommendationProps } from "./recommendation-select-button.type";

import { useObservationUpdate } from "@/entities/observation";

export const useSelectRecommendation = ({
  observationId,
}: UseSelectRecommendationProps) => {
  const { updateObservation } = useObservationUpdate(observationId);

  const onSelectChange = (value: number) => {
    // Fallback to null to dissociate recommendation on select field clear
    updateObservation({ recommendation_id: value ?? null });
  };

  return {
    onSelectChange,
  };
};
